import React, { createContext, useContext, useState, ReactNode } from 'react';

interface AdminDashboardContextType {
  isDashboardLayout: boolean;
  setIsDashboardLayout: (value: boolean) => void;
  currentPage: string;
  setCurrentPage: (page: string) => void;
  pageName: string;
  setPageName: (name: string) => void;
  onMobileMenuOpen: () => void;
  setOnMobileMenuOpen: (callback: () => void) => void;
}

const AdminDashboardContext = createContext<AdminDashboardContextType | undefined>(undefined);

interface AdminDashboardProviderProps {
  children: ReactNode;
}

export const AdminDashboardProvider = ({ children }: AdminDashboardProviderProps) => {
  const [isDashboardLayout, setIsDashboardLayout] = useState(false);
  const [currentPage, setCurrentPage] = useState('');
  const [pageName, setPageName] = useState('');
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const [onMobileMenuOpen, setOnMobileMenuOpen] = useState<() => void>(() => () => {});

  return (
    <AdminDashboardContext.Provider
      value={{
        isDashboardLayout,
        setIsDashboardLayout,
        currentPage,
        setCurrentPage,
        pageName,
        setPageName,
        onMobileMenuOpen,
        setOnMobileMenuOpen,
      }}
    >
      {children}
    </AdminDashboardContext.Provider>
  );
};

export const useAdminDashboard = () => {
  const context = useContext(AdminDashboardContext);
  if (context === undefined) {
    throw new Error('useAdminDashboard must be used within an AdminDashboardProvider');
  }
  return context;
};
